import useAppQuery from 'hooks/useAppQuery';
import { GetAirbnbRatingStatsResponse } from 'models/Reviews';
import { useParams } from 'react-router-dom';
import API from 'services/API';

export const AIRBNB_RATING_STATS_QUERY_KEY = 'airbnbRatingStats';

const useAirbnbRatingStats = () => {
  const { uid: propertyUid } = useParams();

  const { data, isLoading } = useAppQuery(
    [AIRBNB_RATING_STATS_QUERY_KEY, propertyUid],
    async () => {
      const response = await API.get<GetAirbnbRatingStatsResponse>(
        `/api/internal/airbnb-rating-stats/${propertyUid}`,
      );

      return response.data;
    },
    {
      enabled: !!propertyUid,
    },
  );

  return {
    airbnbRatingStats: data,
    isLoading,
  };
};

export default useAirbnbRatingStats;
